import { isCapacitorPlatform } from '@/utils/platform';
import { openStorePage } from './app-update.service';

/**
 * Mostra il dialog nativo di in-app review (per prompt AUTOMATICI dopo momenti
 * positivi). NB: Google può sopprimere il dialog (quota/già recensito) senza
 * errore e senza segnalarlo → non adatto a un bottone manuale "Lascia una
 * recensione" (vedi openReviewPage).
 */
export async function requestInAppReview(): Promise<void> {
  if (isCapacitorPlatform()) {
    try {
      const { InAppReview } = await import('@capacitor-community/in-app-review');
      await InAppReview.requestReview();
      return;
    } catch (err) {
      // fall back below
    }
  }
  await openStorePage();
}

/**
 * Per il bottone MANUALE "Lascia una recensione": apre direttamente la pagina
 * Store. L'In-App Review API di Google sopprime il dialog sui trigger manuali e
 * non riporta se è stato mostrato → un bottone che usa requestReview() spesso
 * "non apre nulla". Aprire lo Store garantisce un comportamento prevedibile.
 */
export async function openReviewPage(): Promise<void> {
  await openStorePage();
}
